import React from "react";
import { Descriptions, Badge, Button } from "antd";
import PreviewDrawer from "../../../../Common/PreviewDrawer";
import { useTranslation } from "react-i18next";
import {
  UserNotification,
  UserNotificationStatus,
} from "../../../../../hooks/api/notifications";
import { UserNotificationStatusLabels } from "..";

interface NotificationViewProps {
  open: boolean;
  onClose: () => void;
  data: UserNotification;
  onMarkAsRead?: (id: string, status: UserNotificationStatus) => void;
}

export default function InboxViewModal(props: NotificationViewProps) {
  const { open, onClose, data, onMarkAsRead } = props;
  const { t } = useTranslation();

  if (!data) return null;

  return (
    <PreviewDrawer
      title={t("pages.notificationCenter.viewNotification")}
      open={open}
      onClose={onClose}
      footer={[
        <Button
          key="save"
          type="primary"
          onClick={() => onMarkAsRead?.(data.id, data.status)}
        >
          {data.status === "UNREAD"
            ? t("pages.notificationCenter.markAsRead")
            : t("pages.notificationCenter.markAsUnread")}
        </Button>,
      ]}
    >
      <Descriptions bordered column={1} className="custom-descriptions">
        <Descriptions.Item
          label={t("pages.notificationCenter.type")}
          className="capitalize-first-letter"
        >
          {data.notification.notificationType}
        </Descriptions.Item>
        <Descriptions.Item label={t("common.table.createdAt")}>
          {data.createdAt}
        </Descriptions.Item>
        <Descriptions.Item label="Status">
          <Badge
            status={
              data.status === "READ"
                ? "success"
                : data.status === "UNREAD"
                  ? "error"
                  : "processing"
            }
            text={UserNotificationStatusLabels[data.status]}
          />
        </Descriptions.Item>
        <Descriptions.Item label={t("pages.notificationCenter.title")}>
          {data.notification.title}
        </Descriptions.Item>
        <Descriptions.Item label={t("pages.notificationCenter.message")}>
          {data.notification.description}
        </Descriptions.Item>
      </Descriptions>
    </PreviewDrawer>
  );
}
